const getSlugFromURL = (url: string): string => {
  if (!url || url.trim() === '') return '';

  return url.substring(url.lastIndexOf('/') + 1);
};

export { getSlugFromURL };
